import React from "react";
import { FormattedMessage } from "react-intl";

import { DownloadButton, DownloadButtonProps } from "@api/components/DownloadButton";
import { WaIcon } from "../WaIcon";
import { messages as uiMessages } from "@ui/messages";

export const DownloadCsvButton = (props: DownloadButtonProps) => (
    <DownloadButton {...props}>
        <WaIcon name="download" />&nbsp;
        <FormattedMessage {...uiMessages.buttonDownloadCsv} />
    </DownloadButton>
);
